module.exports = __webpack_public_path__ + "media/media/favicon/favicon-a5f3768307d4a310b430a478a518b5a3.ico";